import { createSlice } from "@reduxjs/toolkit";
const initialValue = {
  pickUpAddress: null,
  dropOffAddress: null,
};

const BookingAddressSlice = createSlice({
  name: "bookingAddress",
  initialState: initialValue,
  reducers: {
    setPickUpAddress: (state, action) => {
      return {
        ...state,
        pickUpAddress: action.payload,
      };
    },
    setDropOffAddress: (state, action) => {
      return {
        ...state,
        dropOffAddress: action.payload,
      };
    },
    clearBookingAddress: (state, action) => {
      return {
        ...state,
        dropOffAddress: null,
        pickUpAddress: null,
      };
    },
  },
});

const { reducer } = BookingAddressSlice;
export default reducer;
export const { setPickUpAddress, setDropOffAddress, clearBookingAddress } =
  BookingAddressSlice.actions;
